










Transaction = require('models/transaction.coffee')

export default
  name: 'transaction'
  components:
    transaction_amount: require('components/inside/pages/transactions/transaction_amount.vue').default
  props: ['tr']
  computed:
    event_titles_styles: ->
      if @$store.state.ui.transactions.calendar.event_title != 'event_title_long'
        return { height: '20px', 'white-space': 'nowrap' }
    classes: ->
      'animated pulse infinite' if @$store.getters.transactions_past_not_entered.includes?(@tr)
  methods:
    escaped: (category) -> category.replace /'|"|\\/g, '_'
    highlightSimilar: ->
      @$store.state.ui.transactions.calendar.highlighted_transaction = @tr
      return false if @HM.is_touch
      return false if _.isEmpty(@tr.category)
      $('em.highlighted').removeClass('highlighted')
      $("em[data-category='#{@escaped(@tr.category)}']").addClass('highlighted')
    click: ->
      @$store.state.ui.transactions.calendar.highlighted_transaction = null
    unhighlight: ->
      @$store.state.ui.transactions.calendar.highlighted_transaction = null
      return false if @HM.is_touch
      $('em.highlighted').removeClass('highlighted')
